import * as yup from 'yup';

export interface IProductFormValues {
  // Product Details
  productName: string;
  productSku: string;
  linkedTools: Array<{ id: number; name: string; image: string }>;
  category: { label: string; value: string } | null;
  subcategory: { label: string; value: string } | null;
  suppliers: Array<{ id: number; name: string }>;
  manufacturers: Array<{ id: number; name: string }>;

  // Period Details
  licenseQty: string;
  billingPeriod: string;
  snapToUnit: string;
  contractTerm: string;
  contractTermUnit: string;
  contractEnd: string;
  monitoredBySoc: string;
  periodManufacturers: Array<{ id: string; name: string }>;

  // Total Section
  currency: string;
  cost: string;
  taxRate: string;
  usdAmount: string;
  gbpAmount: string;
}

export const productValidationSchema = yup.object().shape({
  productName: yup.string().required('Product Name is required'),
  productSku: yup.string().required('Product SKU is required'),
  linkedTools: yup.array().min(1, 'At least one linked tool is required'),
  category: yup.object().nullable().required('Category is required'),
  subcategory: yup.object().nullable().required('Subcategory is required'),
  suppliers: yup.array().min(1, 'At least one supplier is required'),
  manufacturers: yup.array().min(1, 'At least one manufacturer is required'),
  licenseQty: yup.string().required('License Qty is required'),
  billingPeriod: yup.string().required('Billing period is required'),
  snapToUnit: yup.string().required('Snap to unit is required'),
  contractTerm: yup.string().required('Contract Term is required'),
  contractTermUnit: yup.string().required('Contract Term Unit is required'),
  contractEnd: yup.string().required('Contract End is required'),
  monitoredBySoc: yup.string().required('Monitored by SOC is required'),
  currency: yup.string().required('Currency is required'),
  cost: yup.string().required('Cost is required'),
  taxRate: yup.string().required('Tax Rate is required'),
});

// Re-export initial values from the dedicated file
export { getProductFormInitialValues as getInitialValues } from '../../Components/products/add-product-modal/product-form/initial-values';

